import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet-async";
import { Query } from "react-apollo";

import ErrorBoundary from "components/Library/ErrorBoundary";
import { FRONTEND_ROOT, BACKEND_ROOT } from "config/constants";
import SECTION_STREAM_HELMET_QUERY from "./SectionStreamHelmet.graphql";

export default function SectionStreamHelmet({ slug }) {
  return (
    <ErrorBoundary>
      <Query query={SECTION_STREAM_HELMET_QUERY} variables={{ slug }}>
        {({ loading, data }) => {
          if (loading) return null;

          const { stream } = data;

          return (
            <React.Fragment>
              { stream.lookup !== "top" && (
                <Helmet>
                  <title>{stream.displayName} - Axios</title>
                  <meta property="og:url" content={`${FRONTEND_ROOT}/${stream.lookup}/`} />
                  <meta property="og:title" content={`${stream.displayName} on Axios`} />
                </Helmet>
              )}
              <Helmet>
                <link rel="alternate" type="application/rss+xml" title="Axios" href={`${BACKEND_ROOT}/feed/${stream.lookup}/`} />
              </Helmet>
            </React.Fragment>
          );
        }}
      </Query>
    </ErrorBoundary>
  );
}

SectionStreamHelmet.propTypes = {
  slug: PropTypes.string.isRequired,
};
